import { Button as UnstyledButton } from 'features/common/components/Button';
import { Icon as UnstyledIcon } from 'features/common/components/Icon';
import { Text as UnstyledText } from 'features/common/components/Text';
import { Label as UnstyledLabel } from 'features/common/components/Form/Form.styles';
import styled from 'styled-components';

export const Icon = styled(UnstyledIcon)`
	width: 72px;
	height: 72px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 48px;
		height: 48px;
	}
`;

export const Text = styled(UnstyledText)`
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 153%;
	text-align: center;
	text-transform: none;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding-top: 18px;
	}
`;

export const ContainerBody = styled.div`
	display: flex;
	flex-direction: row;
	gap: 24px;
	height: 100%;
	overflow: hidden;
`;

export const LeftSection = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 24px 20px 24px 0;
	border-right: 1px solid #e5e5e5;
	overflow-y: scroll;
	max-height: 100%;
`;

export const RightSection = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	max-height: 100%;
	overflow: auto;
	padding: 24px 20px;
	min-width: 0; /* Allow flex shrinking */
`;

export const ContainerActionButtons = styled.div`
	display: flex;
	gap: 16px;
	justify-content: center;
	padding: 0px;
`;

export const ModalButton = styled(UnstyledButton)`
	font-size: 14px;
	font-weight: 500;
	font-family: ${({ theme }) => theme.fonts.primary};
	height: 44px;
	line-height: 14px;
	margin: 0;
	padding: 0px;
	width: 125px;
`;

export const SelectTypeContainer = styled.div`
	cursor: pointer;
	display: flex;
	gap: 8px;

	> * {
		cursor: pointer;
	}
`;

export const ModalLabel = styled(UnstyledLabel)`
	color: #222 !important;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		color: #222 !important;
	}
`;

export const EmailPreviewContainer = styled.div`
	border: 1px solid #e5e5e5;
	border-radius: 8px;
	max-width: 600px;
	width: 100%;
	flex: 1;
	overflow-y: auto;
	overflow-x: auto;
	background-color: #f9f9f9;

	iframe {
		width: 100%;
		height: 100%;
		border: none;
	}

	/* ReactQuill stores alignment via ql-align-* classes.
	   Preview HTML is outside .ql-editor, so we must map these classes here. */
	.ql-align-left,
	[class*='ql-align-left'] {
		text-align: left !important;
	}

	.ql-align-center,
	[class*='ql-align-center'] {
		text-align: center !important;
	}

	.ql-align-right,
	[class*='ql-align-right'] {
		text-align: right !important;
	}

	.ql-align-justify,
	[class*='ql-align-justify'] {
		text-align: justify !important;
	}
`;

export const PreviewTitle = styled.h3`
	color: #222;
	font-size: 16px;
	font-weight: 600;
	margin: 0 0 15px 0;
	flex-shrink: 0;
`;

export const PreviewButton = styled(UnstyledButton)`
	width: 100%;
	font-size: 14px;
	font-weight: 500;
	font-family: ${({ theme }) => theme.fonts.primary};
	height: 40px;
	line-height: 14px;
	margin-top: 10px;
`;

export const RichTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
`;

export const StyledQuillWrapper = styled.div`
	.ql-toolbar {
		border: 1px solid #e5e5e5;
		border-bottom: none;
		background: #fff;
	}

	.ql-toolbar .ql-stroke {
		stroke: #222;
	}

	.ql-toolbar .ql-fill {
		fill: #222;
	}

	.ql-toolbar button {
		color: #222;
	}

	.ql-toolbar button:hover {
		background: #f0f0f0;
	}

	.ql-toolbar button.ql-active {
		background: #007bff;
		color: #fff;
	}

	.ql-toolbar button.ql-active .ql-stroke {
		stroke: #fff;
	}

	.ql-toolbar button.ql-active .ql-fill {
		fill: #fff;
	}

	.ql-toolbar .ql-picker-label {
		color: #222;
	}

	.ql-toolbar .ql-picker-options {
		background: #fff;
		border: 1px solid #e5e5e5;
	}

	.ql-toolbar .ql-picker-item {
		color: #222;
	}

	.ql-toolbar .ql-picker-item:hover {
		background: #f0f0f0;
	}

	.ql-container {
		border: 1px solid #e5e5e5;
		background: #fff;
		color: #222;
	}

	.ql-editor {
		color: #222;
		min-height: 120px;
	}

	.ql-editor.ql-blank::before {
		color: #999;
	}

	.ql-container.ql-snow {
		border: 1px solid #e5e5e5;
	}
`;
